export default __webpack_public_path__ + "static/media/gallery-wip-grenade_02.b8f0683e.jpg";